/* Copyright Information: Created by BuyGroup */
import React, { useState, useEffect } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Row,
  Col,
  Spinner,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import classnames from "classnames";
import { getOrderDetails, customerDetail, requestReturn } from "../services/AccountServices";
import UpdateCustomer from "./UpdateCustomer";
import Cards from "./Cards/Cards";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import UserAddress from "./ManageAddress/UserAddress";
toast.configure();
const Account = (props) => {
  const userInitialValues = {
    address_type: "BILLING_ADDRESS",
    id: "",
    address_id: "",
    first_name: "",
    last_name: "",
    company_name: "",
    title: "",
    email: "",
    phone_number: "",
    city: "",
    state: "",
    country: "",
    street: "",
    zip_code: "",
    other_docs: [],
    is_tax_exempt: false,
    fein: ""
  };

  /* const "activeTab" store active tab value */
  const [activeTab, setActiveTab] = useState("1");

  const [isLoading, setLoading] = useState(false);

  /* const "orderList" store order list  */
  const [orderList, setOrderList] = useState([]);

  /* const "initialValues" store user initialvalue data */
  const [initialValues, setUserInitialValues] = useState(userInitialValues);

  const [isDetailLoading, setDetailLoding] = useState(false);

  const [isErrorLoading, setIsErrorLoading] = useState(false);

  // Return related states
  const [returnModal, setReturnModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [returnReason, setReturnReason] = useState("");
  const [returnDescription, setReturnDescription] = useState("");
  const [isReturnLoading, setIsReturnLoading] = useState(false);

  useEffect(() => {
    getorders();
    getCustomerDetail();
  }, []);

  /* This Function will give customer detail */
  const getCustomerDetail = () => {
    setDetailLoding(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const UserId = user.customer_id;
    customerDetail(UserId)
      .then((response) => {
        if (response.status === 200) {
          console.log("response", response);
          if (response.data.company_name === null) {
            response.data.company_name = "";
          }
          if (response.data.title === null) {
            response.data.title = "";
          }
          setUserInitialValues({
            ...response.data,
            tax_exempt_doc_value:
              response.data.tax_exempt_doc.length > 0 ? true : false,
            new_tax_exempt_doc: [],
            delete_tax_doc: [],
            new_other_docs: [],
            delete_other_docs: [],
          });
          setDetailLoding(true);
        }
      })
      .catch((error) => {
        toast.error(error, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setIsErrorLoading(true);
      });
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  /* This function will give order detail of customer */
  const getorders = () => {
    setLoading(true);
    let data = { status: null };
    if (activeTab !== "2") setActiveTab("2");
    getOrderDetails(data)
      .then((response) => {
        if (response.status === 200) {
          setOrderList(response.data.order_list);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  /* This function truncateString the longer  string */
  const truncateString = (string, limit) => {
    if (string.length > limit) {
      return string.substring(0, limit) + "...";
    } else {
      return string;
    }
  };

  // Status mapping for clean display
  const statusDisplayMap = {
    in_progress: "In Progress",
    shipping: "Shipped",
    cancelled: "Cancelled",
    completed: "Delivered",
    return_requested: "Return Requested",
    return_accepted: "Return Accepted",
    return_declined: "Return Declined",
    return_in_progress: "Return In Progress",
    refunded: "Refunded"
  };

  // Return reasons for better organization
  const returnReasons = [
    { value: "defective", label: "Product is defective or not working" },
    { value: "wrong_item", label: "Wrong item received" },
    { value: "not_as_described", label: "Product not as described" },
    { value: "damaged", label: "Product arrived damaged" },
    { value: "size_issue", label: "Size doesn't fit" },
    { value: "quality_issue", label: "Quality not as expected" },
    { value: "changed_mind", label: "Changed my mind" },
    { value: "duplicate_order", label: "Duplicate order" },
    { value: "missing_parts", label: "Missing parts or accessories" },
    { value: "expired", label: "Product expired or near expiry" },
    { value: "other", label: "Other reason" }
  ];

  // Helper function to get display status
  const getStatusDisplay = (status) => {
    return statusDisplayMap[status] || status;
  };

  // Helper function to format currency
  const formatCurrency = (amount) => {
    return parseFloat(amount).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Helper function to calculate total
  const calculateTotal = (order) => {
    return order.price * order.quantity + order.tax_price + parseInt(order.shipping);
  };

  // Helper function to format address
  const formatAddress = (order) => {
    const { street, city, state, country, zip_code } = order.buy_group;
    return `${street}, ${city}, ${state}, ${country}, ${zip_code}`;
  };

  // Return related functions
  const openReturnModal = (order) => {
    setSelectedOrder(order);
    setReturnModal(true);
  };

  const closeReturnModal = () => {
    setReturnModal(false);
    setSelectedOrder(null);
    setReturnReason("");
    setReturnDescription("");
  };

  const handleReturnRequest = () => {
    if (!returnReason.trim()) {
      toast.error("Please select a return reason", {
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }

    setIsReturnLoading(true);
    const returnData = {
      order_id: selectedOrder.order_id,
      order_line_id: selectedOrder.buy_group.order_line_id,
      return_reason: returnReason,
      return_note: returnDescription,
      buy_group_id: selectedOrder.buy_group.buy_group_id,
    };

    requestReturn(returnData)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Return request submitted successfully", {
            autoClose: 3000,
            hideProgressBar: true,
          });
          closeReturnModal();
          getorders(); // Refresh orders to show updated status
        }
      })
      .catch((error) => {
        toast.error(error.data?.message || "Failed to submit return request", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      })
      .finally(() => {
        setIsReturnLoading(false);
      });
  };

  const canRequestReturn = (order) => {
    const status = order.buy_group.status;
    const returnStatuses = ["return_requested", "return_accepted", "return_in_progress", "refunded"];
    return (status === "completed" || status === "delivered") && !returnStatuses.includes(status);
  };

  return (
    <div className="row profile_tabs_vs">
      <div className="col-lg-3 col-md-12">
        <Nav tabs className="profileTab_uline">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                toggle("1");
              }}
            >
              Profile Information
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => {
                getorders();
              }}
            >
              My Orders
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "3" })}
              onClick={() => {
                toggle("3");
              }}
            >
              Saved Cards
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "4" })}
              onClick={() => {
                toggle("4");
              }}
            >
              Manage Shipping Address
            </NavLink>
          </NavItem>
        </Nav>
      </div>
      <div className="col-lg-9 col-md-12">
        <TabContent activeTab={activeTab} className="pr-tab">
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                {isDetailLoading ? (
                  isErrorLoading ? (
                    <h4>No Data Found</h4>
                  ) : (
                    <UpdateCustomer initialValues={initialValues} />
                  )
                ) : (
                  <div className="custom-loader">
                    <Spinner animation="border" />
                  </div>
                )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2" className="myorder">
            {isLoading ? (
              <div className="custom-loader">
                <Spinner animation="border" />
              </div>
            ) : orderList.length > 0 ? (
              orderList.map((order, index) => {
                return (
                  <Row key={order.order_line_id}>
                    <Col sm="12">
                      <Card body className="mb-4">
                        <div className="product_order_grid">
                          <div className="p_order_img">
                            <img
                              className="img-responsive"
                              src={order.buy_group.product_image}
                              alt="not found"
                            />
                          </div>
                          <div className="prod_order_content">
                            <Link
                              to={`/product/${order.buy_group.buy_group_id}`}
                            >
                              <div
                                style={{
                                  color: "#ff4c3b",
                                  paddingBottom: "5px",
                                }}
                              >
                                {truncateString(
                                  order.buy_group.product_name,
                                  170
                                )}
                              </div>
                            </Link>
                            <div className="d-flex align-items-center flex-wrap">
                              <h4>
                                ${" "}
                                {formatCurrency(order.price)}
                              </h4>
                            </div>

                            <ul className="d-flex align-items-center flex-wrap">
                              <li>
                                <strong>Quantity:</strong> {order.quantity}
                              </li>
                              <li>
                                <strong>Tax:</strong> $
                                {formatCurrency(order.tax_price)}
                              </li>
                              <li>
                                <strong>Shipping:</strong> $
                                {formatCurrency(order.shipping)}
                              </li>
                              <li>
                                <strong>Total:</strong> $
                                {formatCurrency(calculateTotal(order))}
                              </li>
                            </ul>
                            <ul className="d-flex align-items-center flex-wrap">
                              <li>
                                <strong>Tracking Company:</strong>{" "}
                                {order.buy_group.tracking_company_name}
                              </li>
                              <li>
                                <strong>Tracking Number:</strong>{" "}
                                {order.buy_group.tracking_number}
                              </li>
                            </ul>
                            <ul className="d-flex align-items-center flex-wrap">
                              <li>
                                <strong>Address:</strong>{" "}
                                {formatAddress(order)}
                              </li>
                            </ul>
                            <ul className="d-flex align-items-center flex-wrap">
                              <li>
                                <strong>Order Id:</strong> {order.order_id}
                              </li>
                            </ul>
                          </div>
                          <div className="prod_order_content_action">
                            <span
                              className={`product_order_status ${order.buy_group.status}`}
                            >
                              {getStatusDisplay(order.buy_group.status)}
                            </span>
                            
                            <span className="order_date">
                              <label>Order Date</label>
                              <p>
                                <Moment format="MM/DD/YYYY">
                                  {order.buy_group.date_created}
                                </Moment>
                              </p>
                            </span>
                            
                            {/* Return Button for completed/delivered orders */}
                            {canRequestReturn(order) && (
                              <Button
                                size="sm"
                                className="btn btn-xs btn-solid return-button width-fill-available"
                                onClick={() => openReturnModal(order)}
                              >
                                Request Return
                              </Button>
                            )}
                            
                            {order.invoice_id !== "NULL" &&
                            order.buy_group.status === "completed" ? (
                              <>
                                <a
                                  href={order.invoice_url}
                                  target="_blank"
                                  className="btn btn-xs btn-solid width-fill-available"
                                >
                                  <i className="fa fa-file-text me-1"> </i>
                                  View Invoice
                                </a>
                              </>
                            ) : null}
                          </div>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                );
              })
            ) : (
              <div className="NotAvailableBox">
                <p>No Orders Available</p>
              </div>
            )}
          </TabPane>
          <TabPane tabId="3">
            <Cards />
          </TabPane>
          <TabPane tabId="4">
            <UserAddress />
          </TabPane>
        </TabContent>
      </div>
      
      {/* Return Request Modal */}
      <Modal isOpen={returnModal} toggle={closeReturnModal} size="lg">
        <ModalHeader toggle={closeReturnModal}>
          <h5 className="mb-0">Request Return</h5>
        </ModalHeader>
        <ModalBody>
          {selectedOrder && (
            <div className="return-request-form">
              {/* Product Information */}
              <div className="selected-product-info mb-4">
                <h6 className="text-muted mb-3">Product Details</h6>
                <div className="d-flex align-items-center p-3 bg-light rounded">
                  <img
                    src={selectedOrder.buy_group.product_image}
                    alt="Product"
                    className="rounded me-3"
                    style={{ width: "60px", height: "60px", objectFit: "cover" }}
                  />
                  <div>
                    <h6 className="mb-1 fw-bold">{selectedOrder.buy_group.product_name}</h6>
                    <small className="text-muted">Order ID: {selectedOrder.order_id}</small>
                  </div>
                </div>
              </div>
              
              {/* Return Form */}
              <Form>
                <FormGroup>
                  <Label for="returnReason" className="fw-bold">
                    Return Reason <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="select"
                    name="returnReason"
                    id="returnReason"
                    value={returnReason}
                    onChange={(e) => setReturnReason(e.target.value)}
                    className="form-select"
                  >
                    <option value="">Select a reason</option>
                    {returnReasons.map((reason) => (
                      <option key={reason.value} value={reason.value}>
                        {reason.label}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label for="returnDescription" className="fw-bold">
                    Additional Details <span className="text-muted">(Optional)</span>
                  </Label>
                  <Input
                    type="textarea"
                    name="returnDescription"
                    id="returnDescription"
                    value={returnDescription}
                    onChange={(e) => setReturnDescription(e.target.value)}
                    placeholder="Please provide additional details about your return request..."
                    rows="4"
                    className="form-control"
                    maxLength="1000"
                  />
                  <small className="text-muted">
                    {returnDescription.length}/1000 characters
                  </small>
                </FormGroup>
              </Form>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeReturnModal} className="px-4">
            Cancel
          </Button>
          <Button 
            color="warning" 
            onClick={handleReturnRequest}
            disabled={isReturnLoading || !returnReason.trim()}
            className="px-4"
          >
            {isReturnLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Account;
/* Copyright Information: Created by BuyGroup */
